(() => {
  let busy = false;
  const units = {'59203385393487':1,'59203384115535':1,'58760817312079':1,'58900606517583':1,'58761265480015':3,'58761296576847':5};
  const handle = async (event, form) => {
    if (!form || form.closest('[data-rw-direct]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || !form.reportValidity()) return;
    busy = true;
    const config = document.querySelector('[data-rw-guard-config]');
    const button = event.submitter || event.target.closest('[data-rw-pay]') || form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    let message = form.querySelector('[data-rw-guard-error]');
    if (!message) { message = document.createElement('p'); message.dataset.rwGuardError = ''; message.setAttribute('role', 'alert'); form.appendChild(message); }
    message.textContent = '';
    try {
      const data = new FormData(form);
      const id = String(data.get('id'));
      const quantity = Number(data.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1) throw new Error(config.dataset.quantity);
      const response = await fetch(window.routes.cart_url + '.js', {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error(config.dataset.error);
      const cart = await response.json();
      const count = cart.items.reduce((sum, item) => sum + (units[String(item.variant_id)] || 0) * item.quantity, 0);
      const added = units[id] || 0;
      const other = cart.items.some(item => !units[String(item.variant_id)]);
      if (count + added * quantity > 5 || (added && other) || (!added && count > 0)) throw new Error(config.dataset.limit);
      const addResponse = await fetch(window.routes.cart_add_url + '.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
      const result = await addResponse.json();
      if (!addResponse.ok) throw new Error(typeof result.description === 'string' ? result.description : config.dataset.error);
      window.location.assign(window.routes.cart_url);
    } catch (error) {
      message.textContent = error.message;
      busy = false;
      if (button) button.disabled = false;
    }
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form instanceof HTMLFormElement && new URL(form.action).pathname.endsWith('/cart/add')) handle(event, form);
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-rw-pay]');
    if (button) handle(event, button.closest('form'));
  }, true);
})();
